import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { getThousandComma } from "../../../../Api/ApiCommon";
import { useApi } from "../../../../hooks/useApi";
import LineBox from "../../../DefaultStyles/LineBox";
import {
  DashBoardSectionTitle,
  DashBoardSectionTitleContainer,
  DashBoardViewDate,
  IndateSectionProps,
} from "./IndateSection";
import ReactApexChart from "react-apexcharts";
import DashBoardToggleBtn from "../DashBoardToggleBtn";

interface AgeSectionProps extends IndateSectionProps {}

export default function AgeSection({ filter, setFilter }: AgeSectionProps) {
  const date = dayjs().format("YYYY-MM-DD");

  const { response } = useApi({
    method: "get",
    url:
      filter.startDate !== "" && filter.endDate !== ""
        ? `dash/total?type=user&subtype=age&startdate=${
            filter?.isAccum
              ? date
              : dayjs(filter.startDate).add(1, "day")?.format("YYYY-MM-DD")
          }&enddate=${
            filter?.isAccum
              ? date
              : dayjs(filter.endDate).add(1, "day")?.format("YYYY-MM-DD")
          }&filter=day`
        : undefined,
  });

  const [series, setSeries] = useState<number[]>([]);

  useEffect(() => {
    let ageList: { age: number; value: number }[] = [];

    if (response?.status === 200) {
      const objByDetail = response.data.reduce((group: any, product: any) => {
        const { detail } = product;

        group[detail] = group[detail] ?? [];
        group[detail].push(product);

        return group;
      }, {});

      const arrByDetail = Object.entries(objByDetail);

      for (let i = 0; i < arrByDetail.length; i++) {
        const element = arrByDetail[i] as any[];
        const age = element[0] as string;
        const elementData = element[1];

        let list = [];
        const init = 0;

        for (let j = 0; j < elementData.length; j++) {
          const el = elementData[j];

          list.push(filter?.isAccum ? el.data.total ?? 0 : el.data.count ?? 0);
        }

        const sumByDate = list.reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          init
        );

        ageList.push({
          age: +age,
          value: sumByDate,
        });
      }

      const underTeenager = ageList
        .filter((a) => a.age <= 10) // 10대 이하
        .reduce((prev, curr) => prev + curr.value, 0);

      const overSixty = ageList
        .filter((a) => a.age >= 60) // 60대 이상
        .reduce((prev, curr) => prev + curr.value, 0);

      setSeries([
        underTeenager,
        ageList.find((a) => a.age === 20)?.value!,
        ageList.find((a) => a.age === 30)?.value!,
        ageList.find((a) => a.age === 40)?.value!,
        ageList.find((a) => a.age === 50)?.value!,
        overSixty,
      ]);
    }
  }, [response, filter]);

  return (
    <>
      <DashBoardSectionTitleContainer>
        <DashBoardSectionTitle>가입자 연령대</DashBoardSectionTitle>

        <DashBoardToggleBtn
          btnTextArray={["기간", "누적"]}
          filter={filter}
          setFilter={setFilter}
        />
      </DashBoardSectionTitleContainer>

      <LineBox boxPadding={"28px 32px"}>
        <DashBoardViewDate>
          {filter?.isAccum
            ? `${filter.endDate} 기준`
            : `조회 기간: ${filter.startDate} ~ ${filter.endDate}`}
        </DashBoardViewDate>

        <>
          <div style={{ width: "100%", height: 330 }}>
            <ReactApexChart
              type="pie"
              height={350}
              series={series}
              options={{
                colors: [
                  "#008FFB",
                  "#00E396",
                  "#FEB019",
                  "#FF4560",
                  "#775DD0",
                  "#546E7A",
                ],
                chart: {
                  type: "pie",
                },
                labels: ["~10대", "20대", "30대", "40대", "50대", "60대~"],
                legend: {
                  position: "bottom",
                  fontFamily:
                    "-apple-system, BlinkMacSystemFont, 'Apple SD Gothic Neo', Pretendard Variable, Roboto, 'Noto Sans KR', 'Segoe UI', 'Malgun Gothic', sans-serif",
                  markers: {
                    width: 10,
                    height: 10,
                    offsetX: -4,
                    radius: 10,
                  },
                  fontSize: "13px",
                  fontWeight: 500,
                  itemMargin: {
                    horizontal: 10,
                  },
                },
                plotOptions: {
                  pie: {
                    dataLabels: {
                      offset: -10,
                      minAngleToShowLabel: 15,
                    },
                  },
                },
                dataLabels: {
                  formatter: (val, { w, seriesIndex }) => {
                    return `${Math.round(Number(val) * 10) / 10}%`;
                  },
                  dropShadow: {
                    blur: 2,
                  },
                  style: {
                    fontWeight: 500,
                  },
                },
                tooltip: {
                  y: {
                    formatter: (val) => `${getThousandComma(val)}명`,
                  },
                },
              }}
            />
          </div>
        </>
      </LineBox>
    </>
  );
}
